<template>
  <v-dialog v-model="dialog" max-width="600px">
    <BaseBodyDialog :title="formTitle" @close="close" @save="save">
      <v-form class="mt-6" ref="form" v-model="valid">
        <v-row>
          <v-col cols="12">
            <v-text-field 
              v-model="editedItem.title" 
              label="Tên cơ sở" 
              outlined 
              dense
              :rules="[$rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea 
              v-model="editedItem.description" 
              label="Địa chỉ" 
              outlined 
              dense
              :rules="[$rules.required]"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </BaseBodyDialog>
  </v-dialog>
</template>

<script>
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'

export default {
  name: 'DepartmentDialog',
  components: {
    BaseBodyDialog
  },
  props: {
    dialog: Boolean,
    formTitle: String,
    editedItem: Object,
  },
  data() {
    return {
      valid: true
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$emit('save')
      }
    },
  },
}
</script>

<style scoped>
.v-card__title {
  font-size: 1.5rem;
}
</style>
